var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 145,
    viewBox: "0 0 276 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.576 144.308C245.863 139.023 213.372 139.901 179.29 144.308C194.824 131.201 208.231 118.093 192.697 104.986C222.998 111.234 227.242 110.601 260.95 104.986C253.132 118.093 267.757 131.201 275.576 144.308Z",
    fill: "#00BC57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M268.328 138.716C243.089 134.497 215.489 135.199 186.537 138.716C199.733 128.254 211.122 117.791 197.926 107.328C223.666 112.315 227.271 111.811 255.904 107.328C249.263 117.791 261.687 128.254 268.328 138.716Z",
    fill: "#00BC57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M258.715 121.858C266.142 121.858 272.163 115.84 272.163 108.417C272.163 100.993 266.142 94.975 258.715 94.975C251.288 94.975 245.267 100.993 245.267 108.417C245.267 115.84 251.288 121.858 258.715 121.858Z",
    fill: "#2F2E41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.667 92.826L206.985 94.379L211.644 107.831L198.185 116.11L182.655 92.826H197.149H197.667Z",
    fill: "#A0616A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M224.068 113.523C236.076 113.523 245.81 103.793 245.81 91.792C245.81 79.79 236.076 70.061 224.068 70.061C212.06 70.061 202.326 79.79 202.326 91.792C202.326 103.793 212.06 113.523 224.068 113.523Z",
    fill: "#A0616A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M103.97 12.628C103.97 12.628 51.168 18.32 41.8501 17.285C32.5322 16.25 28.3908 15.215 28.3908 15.215C28.3908 15.215 22.1789 23.494 25.2849 27.116C27.0244 29.203 29.1293 30.956 31.4968 32.29C31.4968 32.29 37.1911 30.738 41.3325 32.29C45.4738 33.842 87.405 40.568 94.652 34.359C101.899 28.151 103.97 12.628 103.97 12.628Z",
    fill: "#2F2E41"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M107.593 128.01C107.593 128.01 72.91 118.179 66.698 74.717V70.578C66.698 70.578 59.836 82.611 57.38 85.065C54.533 87.911 44.4384 113.523 44.9561 116.11C45.4737 118.697 44.9561 119.732 44.9561 119.732L29.9438 118.179V113.523C29.9438 113.523 37.9676 89.463 38.4853 83.772C39.0029 78.08 58.415 38.499 58.415 38.499C58.415 38.499 65.663 23.494 78.087 38.499C90.511 53.504 91.546 63.852 91.546 63.852L107.593 94.896V128.01Z",
    fill: "#2F2E41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9438 13.663L13.3786 7.972C13.3786 7.972 -2.1514 -3.411 1.4723 7.972C5.0959 19.355 21.6612 44.19 26.3202 41.603C30.9792 39.016 36.5823 32.595 35.3337 31.666C34.0852 30.738 25.8025 24.011 29.9438 13.663Z",
    fill: "#2F2E41"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9461 110.468L18.5738 116.996C18.5738 116.996 2.4027 119.482 11.4212 124.145C20.4397 128.807 45.3184 133.78 46.5623 129.429C47.8062 125.077 47.3127 117.855 46.0045 118.047C44.6964 118.239 35.6779 119.171 31.9461 110.468Z",
    fill: "#2F2E41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M100.864 93.861C100.864 93.861 94.134 122.836 105.523 129.045C116.911 135.254 196.632 136.289 202.844 124.906C209.056 113.523 205.95 113.523 205.95 113.523L189.384 94.896L202.844 93.861C202.844 93.861 202.844 89.722 198.185 89.205C193.526 88.687 179.031 83.513 166.607 87.135C154.183 90.757 146.936 79.891 146.936 79.891L100.864 93.861Z",
    fill: "#575A89"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M92.064 3.315L83.263 51.434L143.83 44.19L154.701 0.727997L92.064 3.315Z",
    fill: "#3F3D56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M93.876 5.126L86.628 48.071L141.759 41.603L152.371 2.539L93.876 5.126Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M85.334 51.951L83.263 51.434L82.228 53.503L98.793 99.553L100.351 98.958L100.864 95.931L85.334 51.951Z",
    fill: "#B3B3B3"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83.263 50.916L99.828 99.035L162.466 89.722L143.83 44.19L83.263 50.916Z",
    fill: "#D0CDE1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91.546 49.364V51.951L137.618 46.777L137.1 44.19L91.546 49.364Z",
    fill: "#3F3D56"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.581 54.538L99.829 74.717L146.936 69.026L138.654 49.882L92.581 54.538Z",
    fill: "#3F3D56"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M151.595 82.996L150.042 78.857C150.042 78.857 138.136 58.16 131.924 62.299C125.712 66.439 144.865 86.618 144.865 86.618H151.077L151.595 82.996Z",
    fill: "#A0616A"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M112.252 86.1L110.699 79.891C110.699 79.891 106.558 60.747 113.805 61.782C121.053 62.817 123.123 80.926 123.123 80.926L122.606 85.065L112.252 86.1Z",
    fill: "#A0616A"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M124.676 83.513C124.676 83.513 111.217 81.443 110.699 84.548C110.182 87.652 107.593 134.219 120.535 135.771C133.477 137.324 197.667 144.05 190.937 128.01C184.208 111.971 173.855 114.04 173.855 114.04L129.853 118.697L124.676 83.513Z",
    fill: "#575A89"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M165.313 89.463L151.595 79.891L142.536 86.876L153.925 99.294L165.313 89.463Z",
    fill: "#575A89"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M128.559 98.777L130.629 118.438L166.348 116.369L135.288 115.851L128.559 98.777Z",
    fill: "black"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M234.8 121.611C249.095 121.611 260.684 110.028 260.684 95.74C260.684 81.452 249.095 69.87 234.8 69.87C220.505 69.87 208.917 81.452 208.917 95.74C208.917 110.028 220.505 121.611 234.8 121.611Z",
    fill: "#2F2E41"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M101.64 20.131L133.736 19.014L136.842 7.196L103.711 8.19501L101.64 20.131Z",
    fill: "#00BC57"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M93.358 26.857L142.018 25.305L142.536 23.235L93.876 24.948L93.358 26.857Z",
    fill: "#E6E6E6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M92.322 32.031L140.983 30.479L141.501 28.409L92.84 30.122L92.322 32.031Z",
    fill: "#E6E6E6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M91.805 36.17L140.465 34.618L140.983 32.548L92.322 34.26L91.805 36.17Z",
    fill: "#E6E6E6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterImage);
export default __webpack_public_path__ + "static/media/footer_image.e6db509d.svg";
export { ForwardRef as ReactComponent };